import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui';

export function CheckoutCancelPage() {
  return (
    <>
      <PageHeader title="Checkout canceled" subtitle="No charges were made." />
      <div className="mx-auto max-w-lg text-center text-sm text-zinc-400">
        <p>You can subscribe anytime from the Coach page.</p>
        <Link to="/coach" className="mt-4 inline-block font-medium text-sky-400 hover:text-sky-300">
          Back to Coach
        </Link>
      </div>
    </>
  );
}
